<template>
    <a
        :href="`/learn/${topic.category.topic.theme.slug}/${topic.slug}`"
        class="md:px-2 cursor-pointer transition ease-in duration-100 transform hover:scale-105"
    >
        <div class="rounded-lg bg-white hover:bg-gray-100 shadow-md hover:shadow-lg border-transparent overflow-hidden h-full">
            <div class="relative h-56 sm:h-60 bg-gray bg-opacity-50 overflow-hidden">
                <img class="absolute inset-0 h-full w-full object-cover" :src="topic.thumbnail" :alt="topic.name" />
            </div>
            <div class="px-6 pt-4 pb-6">
                <p class="mt-2 text-lg line-clamp-2 text-color-heading text-gray-800 font-semibold">
                    {{ topic.name }}
                </p>
                <p class="mt-4 truncate text-gray-600">
                    {{ topic.category.topic.theme.name }}
                </p>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        topic: {
            type: Object,
            required: true
        }
    }
};
</script>
